"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ifIos = exports.ifMobile = exports.renewDate = exports.isSubscribed = void 0;
const moment_1 = __importDefault(require("moment"));
const isSubscribed = (subscription) => { var _a; return ((subscription === null || subscription === void 0 ? void 0 : subscription.stripeData) && !((_a = subscription === null || subscription === void 0 ? void 0 : subscription.stripeData) === null || _a === void 0 ? void 0 : _a.cancel_at_period_end)); };
exports.isSubscribed = isSubscribed;
const renewDate = (subscription) => {
    var _a, _b;
    if (!((_a = subscription === null || subscription === void 0 ? void 0 : subscription.stripeData) === null || _a === void 0 ? void 0 : _a.current_period_end)) {
        return null;
    }
    return moment_1.default.unix((_b = subscription === null || subscription === void 0 ? void 0 : subscription.stripeData) === null || _b === void 0 ? void 0 : _b.current_period_end).format('MM/DD/YYYY');
};
exports.renewDate = renewDate;
const ifMobile = () => window['cordova'] || window['isMobile'];
exports.ifMobile = ifMobile;
const ifIos = () => localStorage.getItem('deviceName') === 'iOS';
exports.ifIos = ifIos;
